// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2c73M","options":"AnswerScale_options__a0k0f","selected":"AnswerScale_selected__2PDhv"};